import { useContext } from "react";

import { DesktopContext } from "@/contexts/DesktopProvider";

export const useDesktop = () => {
    const ctx = useContext(DesktopContext);

    if (!ctx) {
        throw new Error("useDesktop must be used within a DesktopProvider");
    }

    return ctx;
};
